module.exports = "/static/assets/c43622e69ed5cf70575aba04b2c90b9a.png";